<template>
    <span class="ant-input-group-wrapper">
        <span class="ant-input-wrapper ant-input-group">
            <span class="ant-input-group-addon">{{label}}</span>
            <span class="ant-input-affix-wrapper">
                <a-input-number
                    v-model="value" :precision="0" style="border-radius:0 4px 4px 0;" v-bind="$attrs"
                    :formatter="value => `￥ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"/>
            </span>
        </span>
    </span>
</template>

<script>
    export default {
        name: "MoneyInput",
        props: {
            label: String
        },
        computed: {
            value: {
                get() {
                    return this.$attrs.value;
                },
                set(value) {
                    this.$emit("input", value);
                }
            }
        }
    }
</script>
